import ALLOWED_METHODS from 'constants/allowedMethods.const';
import H from 'constants/httpMethod.const';
import fromAnyToString from 'utils/converters/fromAnyToString';
import logger from 'utils/logger.util';

const L = logger('jsonEndpoint');

const jsonEndpoint = (method, uri, data) => {
  let allowedMethod = ALLOWED_METHODS[fromAnyToString(method)];
  if (!allowedMethod) {
    allowedMethod = L.warn('()', 'Not allowed method:', method, 'instead will use:', H.get);
  }

  const endpoint = fromAnyToString(uri);
  if (!endpoint) {
    L.warn('()', 'Invalid uri:', uri);
  }

  const config = {
    headers: { 'Content-Type': 'application/json' },
    method: allowedMethod,
  };

  if (typeof data !== 'undefined') {
    config.body = JSON.stringify(data);
  }

  return Object.freeze({ config: Object.freeze(config), endpoint });
};

// noinspection JSUnusedGlobalSymbols
export default jsonEndpoint;
